import React from 'react';
import ReactDOM from 'react-dom';
import { PORTAL_CONTAINER_ID } from '@/features/modals/components/constants';

export const ModalRenderer: React.FC = ({ children }) =>
  ReactDOM.createPortal(
    children,
    document.getElementById(PORTAL_CONTAINER_ID)!,
  );
